import * as giftManagement from '../services/giftManagement';

export default {
  namespace: 'giftManagementMolding',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //商品管理一览列表
    *getQueryGiftPage({ payload: { values } }, { call, put }) {
      const response = yield call(giftManagement.getQueryGiftPage, values);
      yield put({
        type: 'save',
        payload: {
          queryGiftPage: response?.data,
        },
      });
    },

    *deleteGift({ payload: { values }, callback }, { call }) {
      const res = yield call(giftManagement.deleteGift, values);
      callback(res);
    },
    *canDeleteGift({ payload: { values }, callback }, { call }) {
      const res = yield call(giftManagement.canDeleteGift, values);
      callback(res);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
